import Vue from 'vue'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import '@/styles/element-variables.scss'

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log

import regular_ from './utils/regular.js' // 引用正则验证

Vue.prototype.REGULAR = regular_

import options from './utils/options'
Vue.prototype.OPTIONS = options

import * as filters from './filters' // global filters

import moment from 'moment'
Vue.prototype.$moment = moment

// function clearAllCookies() {
// 	var cookies = document.cookie.split(';')
// 	for (var i = 0; i < cookies.length; i++) {
// 		var cookie = cookies[i]
// 		var eqPos = cookie.indexOf('=')
// 		var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
// 		document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/'
// 	}
// }
// clearAllCookies()
Vue.use(Element, {
	size: Cookies.get('size') || 'medium'
})

Object.keys(filters).forEach((key) => {
	Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

new Vue({
	el: '#app',
	router,
	store,
	render: (h) => h(App)
})
